module.exports = __webpack_public_path__ + "img/mountain-warrior-sheet.c1103c08.png";